type ValidationErrors = { [propName: string]: string };

class ValidationError extends Error {
  errors: ValidationErrors = {};

  constructor(errors: ValidationErrors) {
    super('Validation Errors Occured');
    this.errors = errors;
  }
}

export default ValidationError;
